import {BaseRoleEnum, RoleDto} from "../../services/klaraApi";
import Enumerable from "linq";
import checkIsAdmin from "./checkIsAdmin";

export default function checkBaseRole(baseRole: BaseRoleEnum, roles: Array<RoleDto>) {
    return Enumerable.from(roles).any(t => t.baseRole === baseRole) || checkIsAdmin(roles);
}
